/* eslint-disable @typescript-eslint/no-explicit-any */
// https://www.typescriptlang.org/docs/handbook/decorators.html#method-decorators
export const memo = (_proto: object, name: string, propertyDescr: PropertyDescriptor) => {
  const prevGet = propertyDescr.get;
  if (typeof prevGet !== 'function') {
    throw new Error(`Decorator "${name}" is not a getter`);
  }
  propertyDescr.get = function(this: {[key: string]: unknown}) {
    if (!Object.prototype.hasOwnProperty.call(this, name)) {
      Object.defineProperty(this, name, {
        value: prevGet.call(this),
        enumerable: true,
        configurable: true,
        writable: true,
      });
    }
    return this[name];
  };
  propertyDescr.set = function(this: {[key: string]: unknown}, value: unknown) {
    if (!Object.prototype.hasOwnProperty.call(this, name)) {
      Object.defineProperty(this, name, {
        value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    }
    return true;
  };
  return propertyDescr;
};

export const debuggableClass = (_t: any) => {};
